import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type GiftVoucherModuleSpecsFragment } from '../../../../api/fragments/GiftVoucherModuleSpecs';
import CascaderField from '../../../../components/fields/CascaderField';
import InputField from '../../../../components/fields/InputField';
import useModuleOptions from '../modules/implementations/shared/useModuleOptions';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

type GiftVoucherModuleDetailsFormProps = {
    module: GiftVoucherModuleSpecsFragment;
};

const GiftVoucherModuleDetailsForm = ({ module }: GiftVoucherModuleDetailsFormProps) => {
    const { t } = useTranslation(['moduleDetails', 'giftVoucherModuleDetails']);
    const options = useModuleOptions(module.company, { addNoneOptions: { payment: true } });

    return (
        <StyledContainer gutter={10}>
            <Col md={12} xs={24}>
                <InputField
                    {...t('giftVoucherModuleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>

            {/* we only show when there is payment setting */}
            {options.payment.length > 1 && (
                <Col md={12} xs={24}>
                    <CascaderField
                        {...t('giftVoucherModuleDetails:fields.paymentSetting', {
                            returnObjects: true,
                        })}
                        name="paymentSettingsId"
                        options={options.payment}
                        showSearch
                    />
                </Col>
            )}
        </StyledContainer>
    );
};

export default GiftVoucherModuleDetailsForm;
